import * as React from "react";

import * as S from "@styled";

import { Dropdown } from "@frends/ui-components/react";
import { DropdownProps } from "@frends/ui-components/react/types/Dropdown";

import { ReactComponent as SliderIcon } from "@icons/slider_icon.svg";

export const SmallDropdown: React.FC<DropdownProps> = (props) => (
    <S.SmallDropdownCssPropertiesWrapper>
        <Dropdown {...props} />
    </S.SmallDropdownCssPropertiesWrapper>
);

export const TableSelectColumnsDropdown: React.FC<DropdownProps> = (props) => (
    <S.TableSelectColumnsDropdownCssPropertiesWrapper>
        <Dropdown {...props} hidelabel multivalue hidevalues allowdeselect>
            <SliderIcon />
        </Dropdown>
    </S.TableSelectColumnsDropdownCssPropertiesWrapper>
);

export default Dropdown;
